<template>
  <div
    v-if="open"
    class="jade-floating"
    v-dismiss="computedDismiss"
  >
    <div
      ref="floating"
      v-scroll-lock="open"
      :class="computedClassOverlay"
      :style="{ zIndex }"
      style="
        position: fixed;
        overflow: auto;
        inset: 0px;
        transition-property: opacity;
        transition-duration: 250ms;
      "
    >
      <FocusTrap
        ref="focusTrap"
        :active="open"
        :allowOutsideClick="allowOutsideClick"
        returnFocusOnDeactivate
      >
        <div>
          <slot />
        </div>
      </FocusTrap>
    </div>
  </div>
</template>

<script>
import { FocusTrap } from 'focus-trap-vue'

import dismiss from '@utils/dismiss.directives'

export default {
  name: 'JadeFloating',

  components: {
    FocusTrap
  },

  directives: {
    dismiss
  },

  props: {
    open: Boolean,
    dimmable: Boolean,
    zIndex: {
      type: [String, Number],
      default: 1200
    },
    allowOutsideClick: {
      type: Boolean,
      default: true
    },
    closeOn: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    computedClassOverlay () {
      return {
        'jade-floating__overlay': true,
        'is-clickable': this.allowOutsideClick,
        'is-dimmable': this.dimmable
      }
    },

    computedDismiss () {
      return {
        outsidePressEvent: 'mousedown',
        outsidePress: this.closeOn.includes('outside'),
        escapeKey: this.closeOn.includes('esc'),
        event: () => this.$emit('toggle')
      }
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/floating.css';
</style>
